import * as React from "react";

import { AuthConsumer } from "./authProvider";

export const Callback = () => (
    <AuthConsumer>
        {({ signinRedirectCallback }) => {
            signinRedirectCallback();
        }}
    </AuthConsumer>
);
